<div id="closehelp">
  <p-avatar (click)="closeHelpPanel()" icon="pi pi-times" shape="circle"></p-avatar>
</div>

<div id="helpcontent">
  {{ helpContent }}
</div>